import React from "react";
import { version } from "../../package.json";

export default function Version(props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
    return <div {...props}>{version}</div>;
}